function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.616 5.239a1.313 1.313 0 00-1.857-1.857L24 22.142 5.24 3.382A1.313 1.313 0 003.385 5.24l18.76 18.759-18.76 18.76a1.313 1.313 0 001.857 1.856L24 25.854l18.76 18.76a1.313 1.313 0 001.856-1.857l-18.76-18.759 18.76-18.76z"
});

function SvgClose(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _ref);
}

export default SvgClose;